/**
 * Product images are served from backend at /static/products/
 * Resolves path to full backend URL so images load from API server.
 * Other images (logo, about, hero) stay in frontend /assets/ - do not use this helper for those.
 */
import { API_BASE_URL } from '../api/client';

/** Backend origin (no /api/v1) e.g. https://api.endosurgery.com.my */
export function getBackendBaseUrl() {
  return (API_BASE_URL || '').replace(/\/api\/v1\/?$/, '') || '';
}

/**
 * Resolve product image URL. Use only for product main_image / gallery_images / image from API.
 * Paths from API are /static/products/xxx; frontend assets stay /assets/... (returned as-is).
 * @param {string|null|undefined} path - From API e.g. /static/products/xxx.jpg or frontend /assets/images/...
 * @returns {string|null} Full URL for backend static, or path as-is for frontend/assets
 */
export function getProductImageUrl(path) {
  if (!path || typeof path !== 'string') return null;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = getBackendBaseUrl();
  if ((path.startsWith('/static/') || path.startsWith('/uploads/')) && base) return `${base}${path}`;
  return path;
}

// Fallback removed: product list shows only API image; no placeholder when missing/fails.
// export const PRODUCT_IMAGE_FALLBACK = '/assets/images/no_image.png';
